import React from 'react';
import { X } from 'lucide-react';
import Spreadsheet from 'react-spreadsheet';

interface SpreadsheetCell {
  value: string | number | null;
  className?: string;
}

interface SpreadsheetViewerProps {
  name: string;
  headers: string[];
  data: SpreadsheetCell[][];
  loading?: boolean;
  onClose: () => void;
}

export function SpreadsheetViewer({ name, headers, data, loading, onClose }: SpreadsheetViewerProps) {
  // Custom cell renderer for react-spreadsheet
  const cellRenderer = (props: any) => {
    const { cell, ...rest } = props;
    return (
      <td {...rest} className={`p-2 ${cell.className || ''}`}>
        {cell.value}
      </td>
    );
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900">{name}</h2>
        <button
          onClick={onClose}
          className="flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        >
          <X className="w-4 h-4 mr-2" />
          Close Viewer
        </button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-600"></div>
          <span className="ml-3 text-gray-600">Loading spreadsheet...</span>
        </div>
      ) : data.length > 0 ? (
        <div className="overflow-x-auto">
          <Spreadsheet
            data={data}
            columnLabels={headers}
            hideRowLabels
            darkMode={false}
            CellComponent={cellRenderer}
          />
        </div>
      ) : (
        <div className="text-center text-gray-500 py-12">
          No data available
        </div>
      )}
    </div>
  );
}